import React from "react";

const Questions = ({ post }) => {
  console.log("question", post);
  return (
    <div>
      {/* <h3>{post.name}</h3>
      <h3>{post.description}</h3> */}
    </div>
  );
};

export default Questions;
